import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { OfficeSelectableListModel } from '../../model/officeSelectableListModel';
import { SelectInactiveOfficesToRenewRequestModel } from '../../model/selectInactiveOfficesToRenewRequestModel';
import { SelectInactiveOfficesToRenewResponseModel } from '../../model/selectInactiveOfficesToRenewResponseModel';
import { QuestionnaireQuestionModel } from '../../model/questionnaireQuestionModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../model/submitQuestionnaireAnswersResponseModel';
import { SubmitQuestionnaireAnswersRequestModel } from '../../model/submitQuestionnaireAnswersRequestModel';
import { WorkflowModel } from '../../model/workflowModel';


@Injectable()
export class EntityRenewalService {

    questionnaireQuestionModel : Array<QuestionnaireQuestionModel>;
    private notifyInactiveOfficesToRenewRequest: EventEmitter<SelectInactiveOfficesToRenewRequestModel> = new EventEmitter<SelectInactiveOfficesToRenewRequestModel>();
    private notifyQuestionList: EventEmitter<Array<QuestionnaireQuestionModel>> = new EventEmitter<Array<QuestionnaireQuestionModel>>();
    private notifySelectInactiveOfficesToRenewResponseModel: EventEmitter<SelectInactiveOfficesToRenewResponseModel> = new EventEmitter<SelectInactiveOfficesToRenewResponseModel>();
    private notifySubmitQuestionnaireAnswersResponseModel : EventEmitter<SubmitQuestionnaireAnswersResponseModel> = new EventEmitter<SubmitQuestionnaireAnswersResponseModel>();

    renewalWorkflowModel: WorkflowModel;

    constructor(private http: HttpClient) { }


    getInactiveOffices(workflowID: number) {
        //GET /api/EntityRenewalInactiveOffices
        const params = new HttpParams()
            .set('workflowID', workflowID.toString());
        return this.http.get<OfficeSelectableListModel[]>(environment.server_url + "/api/EntityRenewalInactiveOffices", { params });

    }

    submitInactiveOffices(inactiveOfficesToRenewRequest: SelectInactiveOfficesToRenewRequestModel) {
        //POST /api/EntityRenewalInactiveOffices
        return this.http.post<SelectInactiveOfficesToRenewResponseModel>(environment.server_url + "/api/EntityRenewalInactiveOffices", inactiveOfficesToRenewRequest);

    }

    getEntityQuestionnaire(workflowID: number) {
        //GET /api/EntityRenewalQuestionnaire
        const params = new HttpParams()
            .set('workflowID', workflowID.toString());
        return this.http.get<QuestionnaireQuestionModel[]>(environment.server_url + "/api/EntityRenewalQuestionnaire", { params });

    }

    submitEntityQuestionnaire(questionnaireAnswersRequest: SubmitQuestionnaireAnswersRequestModel) {
        //POST /api/EntityRenewalQuestionnaire
        return this.http.post<SubmitQuestionnaireAnswersResponseModel>(environment.server_url + "/api/EntityRenewalQuestionnaire", questionnaireAnswersRequest);

    }

    getNotifyInactiveOfficesToRenewRequest() {
        return this.notifyInactiveOfficesToRenewRequest;
    }

    getNotifyQuestionList() {
        return this.notifyQuestionList;
    }

    getNotifySelectInactiveOfficesToRenewResponseModel() {
        return this.notifySelectInactiveOfficesToRenewResponseModel;
    }

    getNotifySubmitQuestionnaireAnswersResponseModel(){
        return this.notifySubmitQuestionnaireAnswersResponseModel;
    }

    storeQuestionListData(entityRenewalQuestions : Array<QuestionnaireQuestionModel>){
        localStorage.setItem('entityRenewalQuestions',JSON.stringify(entityRenewalQuestions));

    }

    getQuestionListData(): Array<QuestionnaireQuestionModel>{
        if (localStorage.getItem('entityRenewalQuestions') == null || localStorage.getItem('entityRenewalQuestions') == undefined || isEmpty(JSON.parse(localStorage.getItem('entityRenewalQuestions'))))
            return null;
        return JSON.parse(localStorage.getItem('entityRenewalQuestions'));
        
    }

    clearQuestionListData():void{
        localStorage.removeItem('entityRenewalQuestions');
    }

    storeSubmitQuestionnaireAnswersResponseData(submitQuestionnaireAnswersResponse : SubmitQuestionnaireAnswersResponseModel){
        localStorage.setItem('submitQuestionnaireAnswersResponse',JSON.stringify(submitQuestionnaireAnswersResponse));

    }

    getSubmitQuestionnaireAnswersResponseData(): SubmitQuestionnaireAnswersResponseModel{
        console.log(!isEmpty(JSON.parse(localStorage.getItem('submitQuestionnaireAnswersResponse'))));

        if (localStorage.getItem('submitQuestionnaireAnswersResponse') == null || localStorage.getItem('submitQuestionnaireAnswersResponse') == undefined || isEmpty(JSON.parse(localStorage.getItem('submitQuestionnaireAnswersResponse'))))
            return null;
        return JSON.parse(localStorage.getItem('submitQuestionnaireAnswersResponse'));
    }

    clearSubmitQuestionnaireAnswersResponseData():void{
        localStorage.removeItem('submitQuestionnaireAnswersResponse');
    }

    storeSelectInactiveOfficesToRenewResponseData(inactiveOfficesToRenewResponseModel : SelectInactiveOfficesToRenewResponseModel){
        localStorage.setItem('inactiveOfficesToRenewResponseModel',JSON.stringify(inactiveOfficesToRenewResponseModel));

    }

    getSelectInactiveOfficesToRenewResponseData(): SelectInactiveOfficesToRenewResponseModel{
        if (localStorage.getItem('inactiveOfficesToRenewResponseModel') == null || localStorage.getItem('inactiveOfficesToRenewResponseModel') == undefined || isEmpty(JSON.parse(localStorage.getItem('inactiveOfficesToRenewResponseModel'))))
        return null;
    return JSON.parse(localStorage.getItem('inactiveOfficesToRenewResponseModel'));
      
    }

    clearSelectInactiveOfficesToRenewResponseData():void{
        localStorage.removeItem('inactiveOfficesToRenewResponseModel');
    }
// this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(this.submitEntityQuestionnaireAnswersResponseModel);
        // this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
}

function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}


// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/entity-renewal.service.ts